import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { compose } from 'recompose';
import Navigation from '../../components/Navigation';
import SignInPage from '../SignIn';
import AdminPage from '../Admin';
import { ThemeContext, TableContext } from '../../components/Session';
import { freightLegendTheme } from '../../components/Session/themeContext';
import { MuiThemeProvider } from '@material-ui/core/styles';

import CustomerViewQuotePage from '../Quote/customer_view';
import CustomerViewQuoteConditionsPage from '../Quote/customer_view conditions';
import CustomerViewRateSheetPage from '../RateSheets/customer_view';

import FreightForwarderRouter from '../FreightForwarder/freightForwarderRouter';

import Notifier from '../../components/Notifier';
import ConfirmationDialog from '../../components/Dialog';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import * as ROUTES from '../../constants/routes';
import * as ROLES from '../../constants/roles';
import { withAuthentication, AuthUserContext } from '../../components/Session';
import { withStyles } from '@material-ui/core/styles';
import './App.scss';
import 'react-datasheet/lib/react-datasheet.css';
import { REACT_APP_BASE_PATH } from '../../env';

const styles = (theme) => ({
  paper: {
    padding: '12px',
    margin: '12px',
  },
  root: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);

    this.updateTheme = (theme) => {
      this.setState({ theme });
    };

    this.updateTableSortOptions = (tableSortOptions) => {
      this.setState({ tableSortOptions });
    };

    this.useDefaultTheme = () => {
      this.setState({ theme: freightLegendTheme });
    };

    this.state = {
      theme: freightLegendTheme,
      updateTheme: this.updateTheme,
      useDefaultTheme: this.useDefaultTheme,
      tableSortOptions: {},
      updateTableSortOptions: this.updateTableSortOptions,
    };
  }

  notifyOrchidAdmin = (authUser) => {
    this.props.firebase.notifyOrchidAdminNewUser(authUser.email);
  };

  render() {
    const { classes } = this.props;
    const { tableSortOptions, updateTableSortOptions, theme, updateTheme, useDefaultTheme } = this.state;

    return (
      <ThemeContext.Provider value={{ theme, updateTheme, useDefaultTheme }}>
        <MuiThemeProvider theme={theme}>
          <TableContext.Provider value={{ updateTableSortOptions, tableSortOptions }}>
            <AuthUserContext.Consumer>
              {({ authUser }) => (
                <Router basename={REACT_APP_BASE_PATH}>
                  <ConfirmationDialog />
                  <Notifier />
                  <div className={classes.root}>
                    <Switch>
                      <Route
                        exact
                        path={ROUTES.CUSTOMER_VIEW}
                        render={(props) => (
                          <CustomerViewQuotePage
                            {...props}
                            freight_forwarder_id={props.match.params.freight_forwarder_id}
                            quote_id={props.match.params.quote_id}
                          />
                        )}
                      />
                      <Route
                        exact
                        path={ROUTES.CUSTOMER_VIEW_CONDITIONS}
                        render={(props) => (
                          <CustomerViewQuoteConditionsPage
                            {...props}
                            freight_forwarder_id={props.match.params.freight_forwarder_id}
                            quote_id={props.match.params.quote_id}
                          />
                        )}
                      />
                      <Route
                        exact
                        path={ROUTES.CUSTOMER_VIEW_RATE_SHEET}
                        render={(props) => (
                          <CustomerViewRateSheetPage
                            {...props}
                            freight_forwarder_id={props.match.params.freight_forwarder_id}
                            ratesheet_id={props.match.params.ratesheet_id}
                          />
                        )}
                      />
                      {/* Putting the Navigation here ensures it does not display in CustomerViewQuotePage */}
                      <Navigation />
                    </Switch>

                    <Switch>
                      <Route
                        exact
                        path={ROUTES.LANDING}
                        render={(props) => {
                          if (authUser) {
                            if (!!authUser.roles.includes(ROLES.ADMIN)) {
                              return (
                                <Redirect to={`/freight-forwarders/${authUser.default_freight_forwarder_id}/quotes`} />
                              );
                              // return <FreightForwarderRouter {...props} freight_forwarder_id={authUser.default_freight_forwarder_id} />
                            } else if (authUser.freight_forwarder_id) {
                              return <Redirect to={`/freight-forwarders/${authUser.freight_forwarder_id}/quotes`} />;
                            } else {
                              this.notifyOrchidAdmin(authUser);
                              return (
                                <Paper className={classes.paper}>
                                  <Typography variant="h5" component="h3">
                                    No Freight Forwarder Specified
                                  </Typography>
                                  <Typography component="p">
                                    Please contact Orchid to be assigned to a Freight Forwarder
                                  </Typography>
                                </Paper>
                              );
                            }
                          }
                        }}
                      />
                      <Route path={ROUTES.SIGN_IN} component={SignInPage} />
                      <Route path={ROUTES.ADMIN} component={AdminPage} />
                      <Route
                        path={ROUTES.FREIGHT_FORWARDER}
                        render={(props) => (
                          <FreightForwarderRouter
                            {...props}
                            freight_forwarder_id={props.match.params.freight_forwarder_id}
                          />
                        )}
                      />
                    </Switch>
                  </div>
                </Router>
              )}
            </AuthUserContext.Consumer>
          </TableContext.Provider>
        </MuiThemeProvider>
      </ThemeContext.Provider>
    );
  }
}

// export default withAuthentication(App);

export default compose(withAuthentication, withStyles(styles))(App);
